'use strict';

/*global services*/

$(document).bind('pageLoaded', function () {
    $('#form-change-password').validate({
        rules: {
            new_password2: {
                equalTo: 'input[name=new_password1]'
            }
        }
    });
});
